/* Car Key Shop product page extras: specs + fitment panel read from the description, and the mobile sticky Add to cart bar. */
(function () {
  'use strict';

  var YEAR_RANGE = /\b(?:19|20)\d{2}\s*(?:[-–—]|to)\s*(?:(?:19|20)\d{2}|present|onwards|on)\b|\b(?:19|20)\d{2}\s*(?:onwards|\+|-?\s*present)/i;
  var SPEC = /^([A-Za-z][\w ()\/&.'-]{1,60}?)\s*:\s*(.{1,120})$/;
  var NOT_SPEC = /suitable|compatib|fits|note|please|important|features?|following|warning/i;

  // Text lines from the description: one per leaf block, split on <br> (including <br data-mce-fragment="1"> from Shopify's editor).
  function descLines(root) {
    var out = [];
    root.querySelectorAll('p, li, h2, h3, h4, h5, div, td').forEach(function (el) {
      if (el.querySelector('p, li, div, h2, h3, h4, td')) return;
      el.innerHTML.split(/<br\b[^>]*>/i).forEach(function (part) {
        var tmp = document.createElement('div');
        tmp.innerHTML = part;
        var text = tmp.textContent.replace(/\s+/g, ' ').trim();
        if (text) out.push({ text: text, tag: el.tagName });
      });
    });
    return out;
  }

  function specLabel(label) {
    if (/part\s*n(umber|o)/i.test(label)) return /equivalent|genuine|oem/i.test(label) ? 'Genuine part no.' : 'Part no.';
    return label;
  }

  function buildSpecs() {
    var box = document.querySelector('[data-cks-specs]');
    var tpl = document.querySelector('template[data-cks-desc]');
    if (!box || !tpl) return;
    var root = document.createElement('div');
    root.appendChild(tpl.content.cloneNode(true));
    var lines = descLines(root);

    var specs = [], seen = {}, fits = [], seenFit = {};
    lines.forEach(function (l) {
      var m = l.text.match(SPEC);
      if (m && !NOT_SPEC.test(m[1]) && m[1].split(' ').length <= 8 && !/:$/.test(m[2])) {
        var label = specLabel(m[1].trim());
        var key = label.toLowerCase();
        if (!seen[key] && specs.length < 10) { seen[key] = 1; specs.push([label, m[2].trim()]); }
        return;
      }
      if (l.text.length <= 90 && YEAR_RANGE.test(l.text) && (l.tag === 'LI' || l.text.length <= 60)) {
        var k = l.text.toLowerCase();
        if (!seenFit[k]) { seenFit[k] = 1; fits.push(l.text); }
      }
    });

    if (specs.length) {
      var dl = box.querySelector('[data-cks-spec-list]');
      specs.forEach(function (s) {
        var row = document.createElement('div');
        var dt = document.createElement('dt'); dt.textContent = s[0];
        var dd = document.createElement('dd'); dd.textContent = s[1];
        row.appendChild(dt); row.appendChild(dd); dl.appendChild(row);
      });
      box.querySelector('[data-cks-spec-wrap]').hidden = false;
    }
    if (fits.length) {
      var ul = box.querySelector('[data-cks-fit-list]');
      fits.forEach(function (f) {
        var li = document.createElement('li'); li.textContent = f; ul.appendChild(li);
      });
      box.querySelector('[data-cks-fit-count]').textContent = '(' + fits.length + ')';
      box.querySelector('[data-cks-fit-wrap]').hidden = false;
    }
    if (specs.length || fits.length) {
      box.hidden = false;
      if (!(specs.length && fits.length)) box.classList.add('cks-specs--single');
    }
  }

  // The theme can re-render the product form, so look elements up fresh on every check.
  function stickyBar() {
    if (!document.querySelector('[data-cks-sticky]')) return;
    var ticking = false;

    function check() {
      ticking = false;
      var bar = document.querySelector('[data-cks-sticky]');
      var actions = document.querySelector('.product-info .product-actions');
      var real = document.querySelector('.product-info .button-add-to-cart');
      if (!bar || !actions || !real) return;
      var past = actions.getBoundingClientRect().bottom < 0;
      if (past && !bar.classList.contains('is-visible')) {
        var btn = bar.querySelector('[data-cks-sticky-btn]');
        var price = document.querySelector('.product-info .price .price-item');
        var first = price && price.childNodes[0] && price.childNodes[0].textContent.trim();
        if (first) bar.querySelector('[data-cks-sticky-price]').textContent = first;
        btn.disabled = real.disabled;
        var label = real.querySelector('span');
        if (label) btn.textContent = label.textContent.trim();
      }
      bar.classList.toggle('is-visible', past);
      document.documentElement.classList.toggle('cks-sticky-on', past);
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    window.addEventListener('resize', check);
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cks-sticky-btn]')) return;
      var real = document.querySelector('.product-info .button-add-to-cart');
      if (real && !real.disabled) real.click();
    });
    check();
  }

  function init() { buildSpecs(); stickyBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
